import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {router, navigator} from 'lit-element-router';
import {msg} from '@lit/localize';
import store from '../store';

import getRoutes from '../routes';
import {loadConfigByShortNumber} from '../slices/shortNumberSlice';
import {routeUrl} from '../util/routeUrl';
import {firstSection, setSettingsActive} from '../slices/statusSlice';

@customElement('specification-id-load')
export class SpecificationIdLoad extends connect(store)(router(navigator(LitElement))) {

	static styles = [
		css`
			:host {
				display: flex;
			}

			.shortnumberLoad {
				width: 100%;
			}

			label {
				position: relative;
				display: block;
				cursor: pointer;
			}

			input {
				font-family: var(--font-family-monospace);
				font-size: var(--font-size-widget-small-mono);
				color: var(--color-widget-border-light);
				background-color: transparent;

				min-height: var(--height-widget);
				transition: background-color 0.4s, color 0.4s;
				padding: 0.5em 1em;
				line-height: 120%;
				margin: 0 0 var(--very-small-padding) 0;
				border: 1px solid var(--color-widget-border-light);
				width: 100%;
				box-sizing: border-box;
				text-align: left;
			}
		`
	];

	@property({type: Object})
	params = {};

	@property()
	specificationId = '';

	static get routes() {
		return getRoutes();
	}

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	router(route, params, query, data) {
		this.params = params;
	}
	stateChanged(state) {
		this.dashboardActive = state.status.dashboardActive;
		this.specsheetActive = state.status.specsheetActive;
	}
	onSpecificationId(e) {
		const num = e.target.value;
		if (e.key === 'Enter') {
			this.navigate(routeUrl({media: 'sections', key: num}));
			window.location.reload();
		}
	}

	render() {
		return html`
			<div class="shortnumberLoad">
				<div>${msg('load specification id')}:</div>
				<label class="field-name">
					<div class="shortnumberLoad">
						<input type="text" name="shortNumber" id="shortNumber" .value=${this.specificationId} @input=${this.onSpecificationId}
						       @keypress=${this.onSpecificationId}>
					</div>
				</label>

			</div>
		`;
	}
}
